import { useCallback, useEffect, useMemo, useState } from 'react';
import merge from 'deepmerge';

const serialiseProducts = (products) =>
  JSON.stringify({
    products: products.products.map(({ id }) => id),
    totalNumberOfResults: products.totalNumberOfResults,
    pagesAvailable: products.pagesAvailable,
  });

const productsAreDifferent = (set1, set2) => {
  return serialiseProducts(set1) !== serialiseProducts(set2);
};

export const useProductsDataInitialiser = (products) => {
  const defaultProductsData = {
    products: [],
    totalNumberOfResults: 0,
    pagesAvailable: 1,
    pageNumber: 1,
  };

  const [productContextState, setProductContextState] = useState(
    merge(defaultProductsData, products)
  );

  const setProductContext = useCallback((data) => {
    setProductContextState((prevState) => ({
      ...prevState,
      products: prevState.products.concat(data),
    }));
  }, []);

  useEffect(() => {
    if (productsAreDifferent(products, productContextState)) {
      setProductContextState(merge(defaultProductsData, products));
    }
  }, [products]);

  const returnValue = useMemo(
    () => ({
      ...productContextState,
      setProductContext,
    }),
    [productContextState]
  );

  return returnValue;
};
